/* eslint-disable no-lone-blocks */
import React from "react";
import "@vibe/core/tokens";

import UsageSection from "./Usage/UsageSection";
import ItemViewSection from "./ItemViewSection/ItemViewSection";
import { ITEM_VIEW_COLUMN } from "./ItemViewSection/itemViewLayout";
// import OnboardingSurvey from "./ItemViewSection/OnboardingSurvey"; // onboarding survey disabled
import { useIsItemViewEmpty } from "../hooks/ui";
// import useUser from "../hooks/context/userHook"; // onboarding survey disabled
// import { analytics } from "../utils/segment/analyticsService"; // onboarding survey disabled

interface HomeSectionProps {
  tourState: boolean;
  justAuthorized: boolean;
}

const HomeSection = ({ tourState, justAuthorized }: HomeSectionProps) => {
  const isItemViewEmpty = useIsItemViewEmpty();

  // --- Onboarding survey disabled ---
  // The "What brought you here?" onboarding survey has been temporarily disabled.
  // To re-enable, restore the useUser/analytics imports and useState/useEffect above,
  // and uncomment the block below.
  //
  // const { userId, accountId } = useUser();
  // const surveyKey = userId ? `onboarding_survey_dismissed_${userId}` : null;
  // const [showSurvey, setShowSurvey] = useState(() => {
  //   if (!justAuthorized || !surveyKey) return false;
  //
  //   const surveyState = localStorage.getItem(surveyKey);
  //   return surveyState === "skipped" || !surveyState;
  // });
  //
  // useEffect(() => {
  //   if (justAuthorized && surveyKey && localStorage.getItem(surveyKey) === "skipped") {
  //     localStorage.removeItem(surveyKey);
  //   }
  // // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);
  //
  // const handleDismissSurvey = (selections?: string[]) => {
  //   if (surveyKey) {
  //     localStorage.setItem(surveyKey, selections?.length ? "submitted" : "skipped");
  //   }
  //   if (selections?.length && userId) {
  //     const stringUserId = String(userId);
  //     analytics.identify(stringUserId, {
  //       onboarding_survey_responses: selections,
  //     });
  //     analytics.track("onboarding_survey_completed", {
  //       groupId: accountId ? `${accountId}` : undefined,
  //       selections,
  //       platform: "web",
  //       timestamp: new Date().toISOString(),
  //     });
  //   }
  //   setShowSurvey(false);
  // };
  //
  // if (showSurvey) {
  //   return <OnboardingSurvey onDismiss={handleDismissSurvey} />;
  // }

  return (
    <div className="px-[0.938rem] py-5">
      {!isItemViewEmpty && (
        // Same bounds as the item view column below, so the card's edges line up with it.
        <div className={`mb-[2.25rem] ${ITEM_VIEW_COLUMN}`}>
          <div className="rounded-xl border border-solid border-[var(--layout-border-color)] bg-[var(--primary-background-color)]">
            <UsageSection />
          </div>
        </div>
      )}

      {/* Main Item View Section */}
      <div>
        <ItemViewSection tourState={tourState} />
      </div>
      {/* <ItemsOnBoard /> */}
    </div>
  );
};

export default HomeSection;
